module.exports = __webpack_public_path__ + "img/class_学习者类型.0748c388.png";